import type { REGISTER_INSTITUTE_MODE } from "@features/RegisterInstitute/constants/constants";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface InstituteState {
	instituteId: number | null;
	applicationId: number | null;
	applicationType: string | null;
	subStep: number;
	registerInstituteMode: (typeof REGISTER_INSTITUTE_MODE)[keyof typeof REGISTER_INSTITUTE_MODE] | null;
}

const initialState: InstituteState = {
	instituteId: null,
	applicationId: 19,
	applicationType: null,
	subStep: 0,
	registerInstituteMode: null,
};

const instituteSlice = createSlice({
	name: "institute",
	initialState,
	reducers: {
		setInstituteData(
			state,
			action: PayloadAction<{ instituteId: number; applicationId: number; applicationType: string }>,
		) {
			state.instituteId = action.payload.instituteId;
			state.applicationId = action.payload.applicationId;
			state.applicationType = action.payload.applicationType;
		},
		clearInstituteData(state) {
			state.instituteId = null;
			state.applicationId = null;
			state.applicationType = null;
			state.registerInstituteMode = null;
			state.subStep = 0;
		},
		setSubStep(state, action: PayloadAction<number>) {
			state.subStep = action.payload;
		},
		incrementSubStep(state) {
			state.subStep += 1;
		},
		decrementSubStep(state) {
			state.subStep = Math.max(0, state.subStep - 1);
		},
		setRegisterInstituteMode(
			state,
			action: PayloadAction<(typeof REGISTER_INSTITUTE_MODE)[keyof typeof REGISTER_INSTITUTE_MODE] | null>,
		) {
			console.log("🏛️ Setting registerInstituteMode:", action.payload);
			state.registerInstituteMode = action.payload;
			console.log("🏛️ Updated state registerInstituteMode:", state.registerInstituteMode);
		},
	},
});

export const {
	setInstituteData,
	clearInstituteData,
	setSubStep,
	incrementSubStep,
	decrementSubStep,
	setRegisterInstituteMode,
} = instituteSlice.actions;

export default instituteSlice.reducer;
